import { NoMatchPage } from "components/NoMatchPage";
import PartnerProvider from "context/jobProviders/PartnerProvider";
import { FC } from "react";
import { Route, Routes, useParams } from "react-router-dom";
import { PartnerJobDetailsPage } from "./PartnerJobDetailsPage";

const Router: FC = () => {
  const { token } = useParams();
  return (
    <Routes>
      <Route element={<PartnerProvider token={token} />}>
        <Route path="/*" element={<PartnerJobDetailsPage />} />
      </Route>
      <Route path="*" element={<NoMatchPage />} />
    </Routes>
  );
};
export default Router;
